module.exports = __webpack_public_path__ + "static/media/icon-tag-moduleF2.aca93f44.png";